import React, { useMemo, useCallback } from 'react';
import { IBpaCardBrand } from '../../../bpaState/bpaContext';
import { CardBrands } from 'types';
import { cardBrands } from 'appConstants';
import { ISelectOption } from 'components/Select/types';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormSelectNew } from 'components/Select/FormSelectNew';

interface IProps {
	brandId: string;
	brands: IBpaCardBrand[];
	onChange: ({ brandId, value }: { brandId: string; value: CardBrands }) => void;
}

export const CardBrandSelect: React.FC<IProps> = ({ brandId, brands, onChange }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCardBrand') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(
		() =>
			cardBrands.map((el) => {
				const reservedTariffs = brands
					.filter((brand) => brand.id !== brandId)
					.map((tariff) => tariff.cardBrand);

				return {
					id: el.id,
					name: el.name,
					disabled: reservedTariffs.includes(el.id),
				};
			}),
		[brandId, brands],
	);

	const handleChange = useCallback(
		(value: CardBrands) => {
			onChange({ brandId, value });
		},
		[onChange, brandId],
	);

	return (
		<FormSelectNew
			testId="CardBrandSelect"
			name={`cardBrand-${brandId}`}
			label="cardBrandLabel"
			options={mappedOptions}
			withSearch={false}
			onChange={handleChange}
			validationRules={validationRules}
		/>
	);
};
